import React, { useEffect, useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { checkAccessToken } from "../../services/accreditationServices";
import { useAccreditation } from "../../contexts/AccreditationContext";

const AccessAccreditationPage = () => {
  const { id: competitionId } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("t");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [access, setAccess] = useState(null); // { role, user_email }
  const [error, setError] = useState(null);
  const { setAccreditation } = useAccreditation();

  useEffect(() => {
    const verifyToken = async () => {
      try {
        const result = await checkAccessToken(token);
        if (result.competition_id !== parseInt(competitionId)) {
          throw new Error("Compétition non valide pour ce token.");
        }

        setAccess(result); // ✅ met à jour le state local
        setAccreditation(result); // ✅ met à jour le contexte global

        // Redirection selon le rôle
        const basePath = `/competition/${result.competition_id}`;
        let path = basePath;

        if (result.role === "Pesées") {
          path = `${basePath}/judokas`;
        } else if (result.role === "Répartitions") {
          path = `${basePath}/repartition`;
        } else if (result.role.startsWith("Table")) {
          const tableNumber = result.role.split(" ")[1];
          path = `${basePath}/tapis/${tableNumber}`;
        }

        setTimeout(() => navigate(path), 2000);
      } catch (err) {
        setError(err.message || "Lien d'accès invalide.");
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      verifyToken();
    } else {
      setError("Aucun token fourni.");
      setLoading(false);
    }
  }, [token, competitionId, navigate, setAccreditation]);

  if (loading) return <p className="text-center mt-20">Chargement...</p>;
  if (error) return <p className="text-center mt-20 text-red-500">{error}</p>;

  return (
    <div className="mt-[120px] p-4 text-center">
      <h1 className="text-2xl font-bold mb-4">Accès Accrédité</h1>
      <p className="mb-2">
        Bienvenue <strong>{access.user_email}</strong> 👋
      </p>
      <p>
        Vous êtes accrédité en tant que <strong>{access.role}</strong> pour la
        compétition <strong>#{competitionId}</strong>.
      </p>

      {/* 👉 Redirection ou rendu dynamique ici */}
      <div className="mt-6">
        {access.role === "Pesées" && <p>→ Affichage du module Pesées ici</p>}
        {access.role === "Répartitions" && <p>→ Module Répartitions ici</p>}
        {access.role.startsWith("Table") && (
          <p>→ Accès à la table d’arbitrage : {access.role}</p>
        )}
      </div>
    </div>
  );
};

export default AccessAccreditationPage;
